module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gMVAQM6W9wtEgAAAQtJREFUSMftVjGOwjAQnMUUkdykQqKl5QPXnO4H9wYqHsBz+AhtUt0XqOiPeq2zTo6GhkiRCQQ4Y65guvUmmezsjm2QLElWfDwqkqWQrAB8IA9qIUlkxDhecM7tjTFrAGiaZmmtnSRl7Iqsqt8ki06uOK4lw6hLboxZi4hvYxHxbbWpMEJu5Jb0ZEofPTRJbOGc2wPYtbG19u0qSfvIz+VIvpOk937V885UVTd9kt5NCAAhhMWlylV1m5RwCCGExeDQiIjEhOdyVzigAPCTzIck561tVPWX5Gf08z7Z0Bx7tIl8/DX0/b/uNGUUz2724S097Kt66Jnse+mL8EX4nOPp30taZ+SrkfuqfwCiauTHEyTxoAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/In-White-28px-TM.png
// module id = 29
// module chunks = 0